import {Link, useLocation, useSearchParams} from "react-router-dom";
import {useEffect} from "react";

export default function Pagination({
                                       page,
                                       totalPages,
                                       setPage,
                                       additionalPages,
                                       setAdditionalPages,
                                       baseUrl,
                                       queryString = ''
                                   }: {
    page: number,
    totalPages: number,
    setPage: Function,
    additionalPages: number,
    setAdditionalPages: Function,
    baseUrl: string,
    queryString?: string,
}) {
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();

    useEffect(() => {
        if (searchParams.get('page')) {
            setPage(Number(searchParams.get('page')) || 1)
        }
        // adp (сколько раз нажали «Показать еще») хранится в URL — возврат «назад» восстанавливает его
        setAdditionalPages(Number(searchParams.get('adp')) || 0)
    }, [location.pathname, searchParams.get('page'), searchParams.get('adp')]);


    const hasMore = page + additionalPages < totalPages

    const showMore = () => {
        if (!hasMore) return
        const params = new URLSearchParams(searchParams);
        params.set('adp', String(additionalPages + 1));
        setSearchParams(params, { replace: true, preventScrollReset: true })
        setAdditionalPages(additionalPages + 1)
    }

    const getBaseUrl = () => {
        return baseUrl + (baseUrl.indexOf('?') < 0 ? '?' : '') + 'page='
    }

    const getQueryString = () => {
        return queryString.replace(/&?(page|adp)=(\d+)/g, '').replace(/^&/, '')
    }

    const getPageStructure = () => {
        let t1 = false;
        let t2 = false;
        let t3 = false;
        return [
            Array(totalPages).fill(null).map((_, index) => {
                let cpage = index + 1
                if (cpage <= 2 || Math.abs(cpage - page) <= 2 || totalPages - cpage <= 1) {
                    t3 = false
                    return <li key={index} className={'page-item ' + (cpage === page ? 'active' : '')}><Link className={'page-link '}
                                                 to={getBaseUrl() + cpage + (getQueryString() ? '&' : '') + getQueryString()}>{cpage}</Link>
                    </li>
                }
                if (cpage > 2 && Math.abs(cpage - page) > 2 && !t1) {
                    t1 = true
                    t3 = true
                    return <li key={10000} className={'page-item disabled '}><a className="page-link" href="/" onClick={(event) => {
                        event.preventDefault()
                    }}>...</a></li>
                }
                if (cpage + 2 > page && Math.abs(cpage - page) > 2 && !t2 && !t3) {
                    t2 = true
                    return <li key={20000} className={'page-item disabled '}><a className="page-link" href="/" onClick={(event) => {
                        event.preventDefault()
                    }}>...</a></li>
                }
            })
        ]
    }

    return (<>
        <div className="d-flex flex-column align-items-center pt-5">
            {hasMore && <a className="mb-4 more mx-auto" href={'/'} onClick={(event) => {
                event.preventDefault()
                showMore()
            }}>Показать еще</a>}
            <ul className="pt-1 gap-2 pagination">
                <li className={'page-item  page-item-str ' + (page == 1 ? ' disabled' : '')}>
                    <Link className="page-link"
                          to={getBaseUrl() + (page > 1 ? page - 1 : page) + (queryString ? '&' : '') + getQueryString()}><svg width="7" height="12" viewBox="0 0 7 12" fill="none"
                                                                                                                              xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M6.8987 1.9843V0.927467C6.8987 0.835866 6.79343 0.78528 6.72233 0.841334L0.559053 5.6552C0.506687 5.69592 0.464315 5.74807 0.435168 5.80766C0.406021 5.86725 0.390869 5.93271 0.390869 5.99905C0.390869 6.06539 0.406021 6.13085 0.435168 6.19044C0.464315 6.25003 0.506687 6.30217 0.559053 6.3429L6.72233 11.1568C6.7948 11.2128 6.8987 11.1622 6.8987 11.0706V10.0138C6.8987 9.9468 6.86726 9.88254 6.8153 9.84153L1.89343 5.99973L6.8153 2.15657C6.86726 2.11555 6.8987 2.0513 6.8987 1.9843Z"
                            fill="black" fill-opacity="0.25"/>
                       </svg>
                    </Link>

                </li>
                {getPageStructure()}
                <li className={'page-item  page-item-str ' + (page == totalPages ? ' disabled' : '')}>
                    <Link className="page-link"
                          to={getBaseUrl() + (page < totalPages ? page + 1 : page) + (queryString ? '&' : '') + getQueryString()}>
                        <svg width="7" height="12" viewBox="0 0 7 12" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M6.46854 5.65558L0.305274 0.841708C0.289169 0.829029 0.269815 0.82115 0.249434 0.818975C0.229052 0.8168 0.208471 0.820417 0.190053 0.829412C0.171635 0.838407 0.156128 0.852414 0.145312 0.869825C0.134496 0.887236 0.12881 0.907344 0.128907 0.927841V1.98468C0.128907 2.05167 0.160353 2.11593 0.212306 2.15694L5.13417 6.00011L0.212306 9.84327C0.158986 9.88429 0.128907 9.94855 0.128907 10.0155V11.0724C0.128907 11.164 0.234181 11.2146 0.305274 11.1585L6.46854 6.34464C6.52092 6.30378 6.5633 6.25151 6.59245 6.19181C6.62159 6.13211 6.63674 6.06654 6.63674 6.00011C6.63674 5.93367 6.62159 5.86811 6.59245 5.80841C6.5633 5.74871 6.52092 5.69644 6.46854 5.65558Z"
                                fill="#898A8C"/>
                        </svg>
                    </Link>
                </li>
            </ul>
        </div>
    </>)
}